import type { HttpTransport } from "@common/api/transport";

import type {
  CompanionPlantsAIGenerationParams,
  CompanionPlantsAIGenerationResponse,
  CropSuggestionsAIGenerationParams,
  CropSuggestionsAIGenerationResponse,
  GrowingZoneAIGenerationParams,
  GrowingZoneAIGenerationResponse,
  SeedingDateAIGenerationParams,
  SeedingDateAIGenerationResponse
} from "types/AIGenerations";

type FetchSeedingDateAIGenerationParams = {
  gardenCrop: SeedingDateAIGenerationParams;
  minDate: string;
  randomSeed?: string;
};

export const createAiGenerationsApi = (http: HttpTransport) => ({
  createCompanionPlantsAIGeneration: (
    aiCompanionPlantsGeneration: CompanionPlantsAIGenerationParams
  ) =>
    http.post<CompanionPlantsAIGenerationResponse>(
      "/api/ai_companion_plant_generations",
      { aiCompanionPlantsGeneration }
    ),

  fetchCompanionPlantsAIGeneration: ({
    gardenCropId
  }: CompanionPlantsAIGenerationParams) =>
    http.get<CompanionPlantsAIGenerationResponse | Record<string, never>>(
      `/api/ai_companion_plant_generations`,
      {
        queryParams: { gardenCropId: gardenCropId.toString() }
      }
    ),

  fetchCropSuggestionsAIGeneration: (params: CropSuggestionsAIGenerationParams) =>
    http.post<CropSuggestionsAIGenerationResponse>(
      "/api/ai_crop_suggestions_generations",
      { aiCropSuggestionsGeneration: params }
    ),

  fetchCropSuggestionsAIGenerationStatus: (id: number) =>
    http.get<CropSuggestionsAIGenerationResponse>(
      `/api/ai_crop_suggestions_generations/${id}`
    ),

  fetchGrowingZoneAIGeneration: (
    aiGrowingZoneGeneration: GrowingZoneAIGenerationParams
  ) =>
    http.post<GrowingZoneAIGenerationResponse>("/api/ai_growing_zone_generations", {
      aiGrowingZoneGeneration
    }),

  fetchSeedingDateAIGeneration: ({
    gardenCrop,
    minDate,
    randomSeed
  }: FetchSeedingDateAIGenerationParams) =>
    http.post<SeedingDateAIGenerationResponse>("/api/ai_seeding_date_generations", {
      gardenCrop,
      minDate,
      randomSeed
    })
});
